﻿import { Enumerable, KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { CadLibDimension } from "@models/configurators/output-fields/cad/mates/cad-lib-dimension";
import { CadLibReference } from "@models/configurators/output-fields/cad/mates/cad-lib-reference";
import { Constraint } from "@models/configurators/output-fields/cad/mates/constraint";
import { OutputField } from "@models/configurators/output-fields/output-field";
import { ICadLibFeatureField } from "@models/entity-models";
import { eOutputFieldType } from "@models/enums";

@KboOutputField(CToken.CadLibFeatureField, eOutputFieldType.cadLibFeature)
export class CadLibFeatureField extends OutputField implements ICadLibFeatureField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public libraryFeatureName: string;
    public componentId: string;
    public partFamilyName: string;
    public filePath: string;

    private _references: CadLibReference[];
    @Enumerable()
    public get references(): CadLibReference[] {
        if (!this._references) this._references = [];
        return this._references;
    }
    public set references(val) {
        this._references = val;
    }

    private _dimensions: CadLibDimension[];
    @Enumerable()
    public get dimensions(): CadLibDimension[] {
        if (!this._dimensions) this._dimensions = [];
        return this._dimensions;
    }
    public set dimensions(val) {
        this._dimensions = val;
    }
        
    public addConstraint = (constraintType: eOutputFieldType, args?: any): Constraint => {
        let constraint = OutputField.getNewOutputFieldOfType(constraintType, this.$manager, args);
        constraint.type = constraintType;
        this.$manager.addKbObject(constraint, this);
        if (constraint.type == eOutputFieldType.cadLibReference) {
            this.references.push(constraint as any);
        } else {
            this.dimensions.push(constraint as any);
        }
        return constraint;
    }

    public removeConstraint = constraint => {
        this.$manager.removeKbObject(constraint);
        if (constraint.type == eOutputFieldType.cadLibReference) {
            this.references.remove(constraint as any);
        } else {
            this.dimensions.remove(constraint as any);
        }
    }
}
